import React, { Component, createRef } from "react";
import MobileSubHeader from '../../components/PageHeader/MobileSubHeader';
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { withNamespaces } from "react-i18next";

export class MobileReferral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      referral_code: "",
      referral_link: "",
      referral_settings: []
    };
    this.linkRef = createRef();
  }

  componentDidMount() {}

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  copyToClipboardHandler = event => {
    this.linkRef.current.select();
    document.execCommand("copy");
  }

  render() {
    const { t } = this.props;
    // const icons = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));

    return (
      <Auxiliary>
        <section className="pf-m-dashboard">
            <div className='filters-m-col'>
                <MobileSubHeader
                    className="bg-white"
                    returnPage="/"
                    header={t('promote-link.promote-link')}
                    style={{ justifyContent: "unset" }}
                />
                <div className="pd-m-card-col">
                  <div className="p-3">
                    <div className="mb-1">
                      {t('promote-link.member-title')}
                    </div>
                    <div className="input-group right">
                        <input
                          ref={this.linkRef}
                          type="text"
                          className="form-control"
                          name="referCode"
                          defaultValue={this.props.promote_link_member}
                          readOnly
                        />
                        <span className="input-group-text">
                          <button type="button" className="btn btn-gradient-blue" onClick={(event) => this.copyToClipboardHandler(event)}>
                            {t('promote-link.copy')}
                          </button>
                        </span>
                    </div>
                  </div>
                  <div className="p-3">
                    <div className="mb-1">
                      {t('promote-link.agent-title')}
                    </div>
                    <div className="input-group right">
                        <input
                          ref={this.linkRef}
                          type="text"
                          className="form-control"
                          name="referCode"
                          defaultValue={this.props.promote_link_agent}
                          readOnly
                        />
                        <span className="input-group-text">
                          <button type="button" className="btn btn-gradient-blue" onClick={(event) => this.copyToClipboardHandler(event)}>
                            {t('promote-link.copy')}
                          </button>
                        </span>
                    </div>
                  </div>
                </div>
            </div>
        </section>
      </Auxiliary>
    )
  }
}

export default (withNamespaces("translation")(MobileReferral));